export default __webpack_public_path__ + "static/media/homevilla6.0ab8d6d9.jpg";